import { render, staticRenderFns } from "./chapterList.vue?vue&type=template&id=8c6a8998&scoped=true"
import script from "./chapterList.vue?vue&type=script&lang=js"
export * from "./chapterList.vue?vue&type=script&lang=js"
import style0 from "./chapterList.vue?vue&type=style&index=0&id=8c6a8998&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c6a8998",
  null
  
)

export default component.exports